import { AuthenticationFailed, LayoutType, ReservationOrigin, SubscriptionBillingInterval } from 'gleblu-socket-api';

import { SubscriptionState } from '@/models/interfaces/Subscriptions';

import ReservationRejectReason from '../../models/interfaces/reservation/ReservationRejectReason';
import Translation from './Translation';

const englishTranslation: Translation = {
  menuCategories: 'Menu categories',
  hidden: 'Hidden',
  categories: 'Categories',
  accountingHeader: 'Accounting',
  aboutSlogen: 'Manage your reservations in a single place',
  aboutWhatWeDo: 'What we do',
  aboutWhatWeDoText:
    'Gleblu is an online reservation platform. It matches people, looking for a table, with restaurants. ' +
    'On gleblu.ro you can find a suitable place, reserve a table in seconds, and receive instant confirmation about your reservation. ' +
    'Check the hours or the menu for your favorite restaurant, or discover new places.',
  aboutUs: 'This is Gleblu',
  aboutUsText:
    'Gleblu is a young company. Behind Gleblu there is a small team of software developers. Our superpower is that we are highly motivated. Meet the founders.',
  aboutZsolt:
    'Zsolt is the CEO of Gleblu, a technology entrepreneur with over 3 years of experience in startups and software development. ' +
    'He holds an MSc in Computer Science from ETH Zurich.',
  aboutZsoltJob: 'The operations sensei',
  aboutIstvan:
    'Istvan is the CTO of Gleblu, a software engineer with over 6 years of software development experience. He leads the development of our service. ' +
    'He holds a BSc in Information Engineering from Babes-Bolyai University of Cluj-Napoca.',
  aboutIstvanJob: 'The hacker',
  aboutFindOutMore: 'Find out more',
  aboutHeaderInfo: 'About',
  contactHeader: 'Contact',
  contactMassMedia: 'Are you part of the mass-media?',
  contactMassMediaText: 'Do you want to write about Gleblu? Do you need pictures, logos or interviews? Feel free to email us',
  contactUs: 'Write to us at:',
  contactRestaurant: 'Are you a restaurant?',
  contactRestaurantText:
    'Manage your reservations from multiple sources (like your website, your Facebook page, Facebook Messenger, gleblu.ro) in a single place! ' +
    'You and your staff can check these reservations from any computer, phone or tablet.You can accept or reject reservations from the waitlist, ' +
    'or let Gleblu do the work and automate this process to save time for you.If you connect your Facebook Page with Gleblu’s chatbot, it will reply ' +
    'to your guests on Messenger, provide information about your place and take reservations. Try out for free:',
  contactRelations: 'Customer support',
  reset: 'Reset',
  guestbook: 'Guestbook',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  passwordLabel: 'Password',
  initialPasswordLabel: 'Initial password',
  errorPageMessage: 'Sorry, something went wrong.',
  errorPageAction: 'Home page',
  signupMessage: ['No account yet?', 'Register now!'],
  currentTime: 'Today',
  jumpCurrentTime: 'Jump to today',
  cancelReservationAction: 'Delete reservation',
  notifyGuest: 'You have to notify the guest before you delete the reservation!',
  numberOfGuests: 'Guests',
  table: 'Tables',
  nameLabel: 'Name',
  phoneNumber: 'Phone number',
  enterPhoneNumber: 'Enter your phone number',
  emailAddress: 'Email',
  specialRequest: 'Message',
  editAction: 'Edit',
  editGuestAction: 'Edit guest',
  noTablesSelected: 'No table selected',
  reservationDateInThePast: 'Reservation date in the past',
  cancelAction: 'Cancel',
  saveAction: 'Save',
  editReservationAction: 'Edit reservation',
  newReservationAction: 'New reservation',
  reservationDetails: 'Reservation details',
  reservationManagementPageTitle: 'Reservation management',
  tableStateFree: 'Free',
  tableStatePrepare: 'Prepare',
  tableStateReserved: 'Reserved',
  tableStateReady: 'Ready',
  tableStateSeated: 'Seated',
  missingPageApology: "Sorry but the page you're looking for is missing.",
  missingPageExplanations: "It's possible that this feature is not implemented yet.",
  name: 'Name',
  address: 'Address',
  hoursOfOperation: 'Hours',
  website: 'Website',
  menu: 'Menu',
  websiteInputPlaceholder: "Please enter your website's link",
  menuInputPlaceholder: "Please enter your menu's link",
  pictures: 'Images',
  description: 'Description',
  descriptionPlaceHolder: 'Please describe your place',
  contact: 'Contact',
  accountMenuItemText: 'Account',
  generalSettingsMenuItemText: 'General',
  hoursSettingsMenuItemText: 'Hours',
  picturesSettingsMenuItemText: 'Images',
  reservationSettingsMenuItemText: 'Reservation',
  layoutSettingsMenuItemText: 'Layout',
  settings: 'Settings',
  websiteForGuestsLink: 'Gleblu',
  aboutLink: 'About',
  termsAndConditionsLink: 'Terms',
  privacyLink: 'Privacy',
  sendAction: 'Send',
  sendFeedbackCallToAction: 'Send feedback',
  sendFeedbackDialogTitle: 'Send us feedback',
  sendFeedbackDialogDescription: 'Please fill out the message box below:',
  reservationManagementMenuText: 'Management',
  settingsPageManagementMenuText: 'Settings',
  guestsAnalyticsPageManagementMenuText: "Guests' Analytics",
  reservationsAnalyticsPageManagementMenuText: "Reservations' Analytics",
  guestsFrequency: "Guests's frequency: ",
  firstTimeVisits: 'First time visits:',
  frequentVsFirstTime: 'Frequent guests vs. first time visits',
  averageResponseTime: 'Average response time to pending reservations:',
  pastReservationsNr: 'Number of past reservations:',
  upcomingReservationsNr: 'Number of upcoming reservations:',
  pendingReservationsMenuText: 'Waitlist',
  conflictingReservationsMenuText: 'Resolve errors',
  languageMenuText: 'Language',
  addNewPlaceMenuText: 'Add new place',
  signOutMenuText: 'Sign out',
  required: 'Required',
  mustBeNumeric: 'Invalid number',
  mustBeUrl: 'Invalid web address',
  mustBePhoneNumber: 'Invalid phone number',
  mustBeEmailAddress: 'Invalid email address',
  maximumAllowedValue: (maxValue: number) => `Maximum value is ${maxValue}`,
  minimumAllowedValue: (minValue: number) => `Minimum value is ${minValue}`,
  alreadyAdded: 'Already added',
  maximumNumberOfGuestsSettingLabel: 'Number of guests',
  maximumNumberOfGuestsSentenceStart: 'Allow maximum',
  maximumNumberOfGuestsSentenceEnd: 'per reservation.',
  maximumNumberOfReservationsSettingLabel: 'Number of reservations',
  maximumNumberOfReservationsSentenceStart: 'Allow maximum',
  maximumNumberOfReservationsSentenceEnd: 'simultaneously.',
  durationSettingLabel: 'Duration',
  durationSmallGroupSentenceStart: 'Keep the table reserved for',
  durationSmallGroupSentenceEnd: 'for 2 guests.',
  durationMediumGroupSentenceStart: 'Keep the table reserved for',
  durationMediumGroupSentenceEnd: 'for 3-6 guests.',
  durationLargeGroupSentenceStart: 'Keep the table reserved for',
  durationLargeGroupSentenceEnd: 'for 7+ guests.',
  waitingTimeSettingLabel: 'Waiting time',
  waitingTimeSettingSentenceStart: 'Cancel the reservation if the guest is late by',
  minimumLeadTimeSettingLabel: 'Minimum lead time',
  minimumLeadTimeSettingSentenceStart: 'Allow guests to reserve a table minimum',
  minimumLeadTimeSettingSentenceEnd: 'in advance.',
  maximumLeadTimeSettingLabel: 'Maximum lead time',
  maximumLeadTimeSettingSentenceStart: 'Allow guests to reserve a table maximum',
  maximumLeadTimeSettingSentenceEnd: 'in advance.',
  preReserveSettingLabel: 'Pre-reserve',
  preReserveSettingSentenceStart: 'Prepare the table',
  preReserveSettingSentenceEnd: 'before the reservation.',
  minuteSingular: 'minute',
  minutePlural: 'minutes',
  minutePreReserveSingular: 'minute',
  minutePreReservePlural: 'minutes',
  hourSingular: 'hour',
  hourPlural: 'hours',
  hourDurationSingular: 'hour',
  hourDurationPlural: 'hours',
  daySingular: 'day',
  dayPlural: 'days',
  reservationSingular: 'reservation',
  reservationPlural: 'reservations',
  guestSingular: 'guest',
  guestPlural: 'guests',
  guests: (numberOfGuests: number) => (numberOfGuests === 1 ? 'guest' : 'guests'),
  open: 'open',
  closed: 'closed',
  mapView: 'Map view',
  scheduleView: 'Schedule view',
  switchToCurrentTime: 'Jump to today',
  turnCurrentTimeOff: 'Turn off',
  opensEarlierThanClosesErrorMessage: "Opens earlier than previous day's closing time",
  closesLaterThanOpensErrorMessage: "Closes later than next day's opening time",
  closedOnThisDate: 'Your place is closed at this time.',
  closedOnThisDay: 'Your place is closed on this day.',
  noTableSuggestion: 'No suggestion',
  suggestedTable: 'Suggestion',
  accept: 'Accept',
  reject: 'Reject',
  changePlan: 'Change Plan',
  change: 'Change',
  resolveAction: 'Resolve',
  autoResolveAction: 'Auto resolve',
  timeCaption: 'Time',
  vatNumberLabel: 'VAT number',
  emailAddressPlaceholder: 'example@email.com',
  newPasswordLabel: 'New password',
  confirmPasswordLabel: 'Confirm password',
  passwordTooShort: 'Password too short',
  passwordsDoNotMatch: 'Passwords do not match',
  weakPasswordNoNumber: 'Weak password: must contain number',
  weakPasswordNoUppercase: 'Weak password: must contain uppercase letter',
  weakPasswordNoLowercase: 'Weak password: must contain lowercase letter',
  login: 'Sign in',
  contactPerson: 'Contact person',
  company: 'Company',
  companyName: 'Company name',
  register: 'Register',
  inProgress: 'In progress',
  completed: 'Completed',
  retry: 'Retry',
  registrationSuccessful: 'Registration successful',
  registrationFailed: 'Registration failed',
  checkConfirmationEmail: 'Please check your inbox for the confirmation email.',
  retryLater: 'Please try again later',
  emailVerificationFailed: 'Email verification failed',
  errorOccurred: 'An error occurred',
  tokenInvalidOrExpired: 'Token invalid or expired',
  resendToken: 'Resend activation token',
  missingToken: 'Token is missing',
  emailVerified: 'Email verified',
  minimumCharacters: (value: number) => `Minimum ${value} characters`,
  submit: 'Submit',
  placeNameLabel: 'Place name',
  placeNamePlaceholder: 'Enter place name',
  streetLabel: 'Street',
  streetPlaceholder: 'Enter street name',
  houseNumber: 'Number',
  houseNumberPlaceholder: 'Enter house number',
  cityLabel: 'City',
  cityPlaceholder: 'Enter city name',
  countryLabel: 'Country',
  countryPlaceholder: 'Enter country name',
  didYouMean: 'Did you mean',
  selectAction: 'Select',
  contributors: 'Contributors',
  placeSetupPageTitle: 'Set up your place',
  reservationLayoutTypeLabel: 'Indoors or outdoors',
  addAction: 'Add',
  modifyAction: 'Modify',
  tableLabelLabel: 'Label',
  tableCapacityLabel: 'Seats',
  tableLabelPlaceholder: 'Enter label',
  tableCapacityPlaceholder: 'Enter number of seats',
  labelAlreadyTaken: 'This label is already taken',
  tables: 'Tables',
  leavePageDialogTitle: 'Leave page',
  leavePageDialogContent: 'You have changes that will be lost if you continue.',
  leavePageDialogConfirmAction: 'Leave page',
  reloadTitle: 'Reload',
  reloadContent: 'Data was changed by someone else. Please reload the page to continue.',
  reloadAction: 'Reload',
  addNewReservation: 'Add new reservation',
  takeSuggestionAction: 'Take',
  latitudeLabel: 'Latitude',
  longitudeLabel: 'Longitude',
  activationSuccessful: 'Activation successful',
  activationFailed: 'Activation failed',
  enableReservationsSuccessful: 'Reservations enabled successfully',
  enableReservationsDescription: 'You will get an email when guests make a reservation in the Gleblu App',
  enableReservationsFailed: 'Enabling reservations failed',
  disableReservationsSuccessful: 'Reservations disabled successfully',
  disableReservationsDescription: 'Guests will not be able to make reservatiosn in the Gleblu App',
  disableReservationsFailed: 'Disabling reservations failed',
  enableGuestWebSuccessful: 'Re-add successful',
  enableGuestWebDescription: 'We have re-added your place to the Gleblu App, guests will be able to find it',
  enableGuestWebFailed: 'Re-adding place failed',
  disableGuestWebSuccessful: 'Remove successful',
  disableGuestWebDescription: 'We have removed your place from the Gleblu App, guests will not see it anymore',
  disableGuestWebFailed: 'Removing place failed',
  placeLabel: 'Place',
  googlePlaceId: 'Google place id',
  facebookPageToken: 'Facebook page token',
  facebookPageId: 'Facebook page id',
  and: 'and',
  acceptTerm: (button: string) => `By pressing the button "${button}" you accept the:`,
  automatic: 'Automatic',
  outsideHours: 'The reservation is outside the open hours',
  durationTooHigh: 'Duration higher than default',
  durationTooLow: 'Duration lower than default',
  tableNotAvailable: 'Some tables are not available',
  capacityTooHigh: 'Capacity too high',
  capacityTooLow: 'Capacity too low',
  deleteAction: 'Delete',
  layoutTypesTitle: {
    [LayoutType.indoor]: 'Indoors',
    [LayoutType.outdoor]: 'Outdoors',
  },
  loginFailed: {
    [AuthenticationFailed.invalidEmailOrPassword]: 'Login failed',
    [AuthenticationFailed.notActivated]: 'Email address not confirmed',
  },
  totalCapacity: 'Total seats',
  timeInterval: 'Tables reserved',
  reservationDateLabel: 'Reservation date',
  pageNotFoundTitle: 'Page not found',
  placeNotFoundTitle: 'Place not found',
  placeNotFoundReason: 'The place does not exist.',
  facebookLogin: 'Login and select your facebook page!',
  selectedFacebookPage: 'The selected page is:',
  facebookPages: 'Facebook pages',
  resetStepper: 'Reset',
  stepperBack: 'Back',
  unknownStep: 'Unknown step',
  firstStep: 'Login with Facebook',
  secondStep: 'Select Facebook page',
  thirdStep: 'Subscribe to Chatbot',
  chatbotSettingsMenuItem: 'Chatbot',
  automaticReservationMenuItem: 'Automatic Reservation',
  automaticReservationDescription: 'Gleblu can accept the reservations automatically and assign them to corresponding tables.',
  tableNotInLayoutType: {
    [LayoutType.indoor]: 'Some tables are not indoor',
    [LayoutType.outdoor]: 'Some tables are not outdoor',
  },
  phoneNumberNotSet: 'Phone number is not set',
  guestWebEnabledLabel: 'Visibility',
  guestWebEnabledSwitch: { true: 'Visible for guests on the Gleblu App', false: 'Invisible for guests on the Gleblu App' },
  acceptsReservationsLabel: 'Reservations',
  acceptsReservationsSwitch: { true: 'Enabled', false: 'Disabled' },
  autoAcceptReservationLabel: 'Accept automatically',
  autoAcceptReservation: { true: 'Automatic', false: 'Not automatic' },
  guestsArrived: 'Guests arrived',
  errors: {
    wrongPassword: 'Wrong password.',
    emailAddressNotFound: 'Email address not found.',
    invalidToken: 'Token is invalid.',
    expiredToken: 'Token is expired.',
    operationAlreadyCompleted: 'Operation has been already completed.',
    placeDisabled: '',
  },
  forgotPasswordLink: 'Forgot password?',
  passwordResetLinkSendingError: 'Could not send password reset link!',
  passwordResetLinkSentSuccessfully: 'Password reset link sent. Check your inbox.',
  passwordResetFailed: 'Could not change password',
  passwordResetSuccessful: 'Password changed. You can sign in with your new password.',
  passwordChangeFailed: 'Could not change password',
  noSpecialHours: 'No days with special hours',
  date: 'Date',
  hoursTableHeader: 'Hours',
  specialHourDateAlreadyAdded: 'You have already added special hours for this date',
  announcements: {
    ReservationCreated: 'Reservation created',
    ReservationCreationFailed: 'Could not create the reservation. Please try again later.',
    ReservationOutsideHours: 'Could not create the reservation, it is outside the open hours.',
    ReservationUpdated: 'Reservation updated',
    ReservationUpdateFailed: 'Could not update the reservation. Please try again later.',
    ReservationCanceled: 'Reservation deleted',
    ReservationCancelFailed: 'Could not delete the reservation. Please try again later.',
    ReservationStateUpdated: 'Reservation state updated',
    ReservationStateUpdateFailed: 'Could not update the reservation state. Please try again later.',
    FeedbackReceived: 'Feedback received. Thank you!',
    FeedbackFailed: 'Could not send your feedback. Please try again later.',
    ContactSaved: 'General settings saved',
    ReservationSettingSaved: 'Reservation settings saved',
    ProfileSaved: 'Images saved',
    LayoutSaved: 'Tables saved',
    EmployeeUpdated: 'Employee updated',
    EmployeeUpdateFailed: 'Employee update failed',
  },
  employees: 'Employees',
  permissions: 'Permissions',
  assignedTables: 'Assigned tables',
  workingSchedule: 'Working schedule',
  permissionLevels: { unauthorized: 'Unauthorized', view: 'View', edit: 'Edit' },
  reservationPermission: 'Reservation permission',
  settingPermission: 'Settings permission',
  emptyDataSourceMessage: 'No records to display',
  filterTooltip: 'Filter',
  rowDeleteConfirmation: 'Are you sure you want to delete this row?',
  actionsTooltip: 'Actions',
  groupedBy: 'Grouped by',
  dragHeaders: 'Drag headers',
  firstPage: 'First Page',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  lastPage: 'Last Page',
  displayedRowsLabel: '{from}-{to} of {count}',
  rowsPerPageLabel: 'Rows per page',
  rowsLabel: 'Rows',
  addOrRemoveColumns: 'Add or remove columns',
  showColumns: 'Show Columns',
  exportTooltip: 'Export',
  exportAsCsv: 'Export as CSV',
  searchTooltip: 'Search',
  deletePermissionRowConfirmation: 'Are you sure you want to delete this permission?',
  noProfileImage: 'No profile image',
  uploadTakesTime: 'Please be patient. The upload may take some time.',
  employeesToBeInvited: 'Employees to be invited',
  alreadyInvited: 'Already invited',
  emailTextAreaPlaceholder: 'Type or paste email addresses and press "Enter"',
  extractEmails: 'Add emails',
  noEmailsFoundInInput: 'Could not find any emails',
  inviteEmployeesSubmitError: 'Could not invite employees',
  originTitle: {
    [ReservationOrigin.chatbot]: 'Facebook Messenger',
    [ReservationOrigin.facebookTab]: 'Facebook Tab',
    [ReservationOrigin.guestWeb]: 'Gleblu.ro',
    [ReservationOrigin.guestApp]: 'Gleblu App',
    [ReservationOrigin.placeWeb]: 'Gleblu Business',
    [ReservationOrigin.webWidget]: 'Web widget',
    [ReservationOrigin.authenticatedGuestWeb]: 'Authenticated Gleblu.ro',
  },
  unauthorizedToViewReservations: "You don't have permission to view reservations",
  unauthorizedToViewPlaceSettings: "You don't have permission to view the place settings",
  unauthorizedToViewCompanySettings: "You don't have permission to view the company settings",
  unauthorizedToAddPlaces: "You don't have permission to add new place",
  unauthorizedToViewPlace: "You don't have permission to access the place",
  createdBy: 'Created by',
  updatedBy: 'Updated by',
  nextDay: 'next day',
  notAvailable: 'Not available',
  reservationRejectReasons: {
    [ReservationRejectReason.OutsideHours]: 'The reservation is outside the open hours',
    [ReservationRejectReason.Unknown]: 'An error occurred',
  },
  loggedInGreeting: 'Hi! How can we help you?',
  loggedOutGreeting: 'Hi! How can we help you?',
  landingPageTitle: 'Manage your reservations in a single place!',
  landingPageSubtitle: 'From your website, your Facebook page, Facebook Messenger, Google search and map, gleblu.ro',
  learnMore: 'Learn more',
  userHasAccount: 'Already have an account?',
  landingPageWaitingTexts: [
    'You and your staff can check these reservations from any computer, laptop, POS, phone or tablet.',
    'All you need is a web browser.',
    'You can accept or reject reservations from the waitlist, or let Gleblu do the work and automate this process to save time for you.',
  ],
  landingPageChatbotTexts: [
    'If you connect your Facebook Page with Gleblu’s chatbot, it will reply to your guests on Messenger,' +
      ' provide information about your place and take reservations.',
  ],
  errorsResolved: 'All errors resolved',
  seatingStartsBeforeOpening: 'Tables reserved before opening time',
  seatingEndsAfterClosing: 'Tables reserved after closing time',
  layoutClosed: 'Layout is closed',
  languages: {
    en: 'English',
    hu: 'Hungarian',
    ro: 'Romanian',
  },
  userNotAddedToPlaces: 'You are not added to any places',
  contactAdministrator: 'Please contact your system administrator',
  layoutLabel: 'Label',
  layoutTypeLabel: 'Indoors or outdoors',
  availability: 'Availability',
  createLayoutTitle: 'Create layout',
  stringMaximumLength: (maxLength: number) => `Maximum length allowed is ${maxLength}`,
  pricingDescription: 'Chose a subscription that fits your case',
  pricingTitle: {
    [SubscriptionBillingInterval.MONTH]: 'Monthly',
    [SubscriptionBillingInterval.YEAR]: 'Yearly',
  },
  pricingInterval: {
    [SubscriptionBillingInterval.MONTH]: 'per month',
    [SubscriptionBillingInterval.YEAR]: 'per year',
  },
  subscriptionState: {
    [SubscriptionState.ACTIVE]: 'Active',
    [SubscriptionState.UNDETERMINED]: 'Undetermined',
    [SubscriptionState.TERMINATED]: 'Inactive',
  },
  currentSubscription: 'Current subscription:',
  activeUntil: (date: string) => `until ${date}`,
  subscribe: 'Subscribe',
  resubscribe: 'Resubscribe',
  staySubscribed: 'Stay Subscribed',
  trialDescription: 'First 30 days are free',
  chatbotDescription: [
    'First, connect the Gleblu with your Facebook page, then you will be able to subscribe to our chatbot.',
    'Our chatbot can talk to your clients over Messenger in three different languages: English, Romanian and Hungarian.',
    'It can also take table reservations for you.',
  ],
  processingSubscription: 'Processing subscription...',
  changeInitialPasswordTitle: 'Change initial password',
  changeInitialPasswordExplanation: 'For security reasons, you must change your initial password before accessing your account.',
  hoursRequired: `To manage reservations, please specify the restaurant's open hours first.`,
  hoursSet: `Now that you've set the open hours, you can enable reservations`,
  defineLayoutDescription: 'Automatic reservation needs to know the layout and tables of the place.',
  rejectReservationFailed: 'Rejecting reservation failed',
  acceptReservationFailed: 'Accepting reservation failed',
  reservationConfirmationDescription: 'You can view all reservations in the Gleblu App after logging in',
  reservationRejectedSuccessfully: 'Reservation rejected successfully',
  reservationAcceptedSuccessfully: 'Reservation accepted successfully',
  reservationExpired: 'The reservation already expired',
  reservationNotPending: 'The reservation is already accepted or rejected',
  reviewRequiredPageTitle: 'Review required',
  reviewRequiredPageContent: (placeName) => [
    `'${placeName}' is currently under review by the Gleblu team.`,
    `We'll notify you by email once the review is complete and your page has been approved.`,
    `Thank you for your patience.`,
  ],
  delete: 'Delete',
  deleteAccountDialogTitle: 'Delete account',
  deleteAccountDialogContent: 'Are you sure you want to delete your account?',
  deactivatedAccount: 'Deactivated account',
  deactivatedAccountPageParagraphs: [
    'Your account has been deactivated.',
    `You won't be able to sign in or access your profile until it's reactivated.`,
    `Some features may have been deactivated along with your account. After reactivating your account, please review them under the 'Settings' menu item.`,
  ],
  reactivate: 'Reactivate',
  accountDeletionSucceeded: 'Your account has been deleted successfully.',
  accountDeletionFailed: 'We could not delete your account.',
  deleteYourAccount: 'Delete your account',
  deleteYourAccountParagraphs: [
    'If you no longer wish to use our service, you can delete your account.' +
      " We'll retain your personal data for a limited period before permanently deleting it.",
    "Changed your mind? You can reactivate your account by logging in and clicking 'Reactivate', as long as your personal data is still available.",
  ],
};

export default englishTranslation;
